

import React from "react";
import Styles from "./styles.module.scss";
import { RadioButton } from "@progress/kendo-react-inputs";
import shortTerm from '../../assets/images/short-term-icon.svg';
import shortTermWhite from '../../assets/images/short-term-icon-white.svg';
import mediumTerm from '../../assets/images/medium-term-icon.svg';
import mediumTermWhite from '../../assets/images/medium-term-icon-white.svg';
import longTerm from '../../assets/images/long-term-icon.svg';
import longTermWhite from '../../assets/images/long-term-icon-white.svg';

// interface to declare all our prop types
interface Props {
  label?: string;
  name?: string;
  value?: number;
  defaultChecked? :boolean;
  disabled?: boolean;
  handleChange?: any;
  duration?: string
  checked?: boolean;
  size?: string;
}


const RadioDefault: React.FC<Props> = ({
  label = '',
  name = '',
  value = '',
  defaultChecked,
  handleChange,
  duration,
  checked,
  size,
  ...rest
}) => {
  return (
    <div className={Styles.durationCheck}>
      <label className={Styles.duration}>
        {/* <RadioButton
          name={name}
          value={value}
          // label={label}
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={handleChange}
        /> */}
        <input type="radio" id="html" name={name} value={value} checked={checked} onChange={handleChange}/>
        
        <div className={Styles.checkmark} >
          {/* <img src={shortTerm}/> */}
          {/* <img src={shortTermWhite} className={Styles.hover}/> */}
          {/* <span>{label}</span> */}
          {duration}
        </div>
      </label>
    </div>
  );
};

export default RadioDefault;


